module.exports = __webpack_public_path__ + "img/10.cb1116be.jpg";